module.exports = __webpack_public_path__ + "static/media/quoraLogo.4b2938b9.png";